import React from 'react'
import { cn } from '@/lib/utils'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'outline' | 'default' | 'link'
  size?: 'sm' | 'md' | 'lg'
  children: React.ReactNode
}

// Helper function for calendar component
export function buttonVariants({ variant }: { variant?: 'outline' | 'ghost' }) {
  const baseClasses = 'inline-flex items-center justify-center rounded-monumenta font-medium transition-all duration-200'

  if (variant === 'outline') {
    return cn(baseClasses, 'border border-brand-gray/20 hover:bg-brand-dark-lighter')
  }
  if (variant === 'ghost') {
    return cn(baseClasses, 'hover:bg-brand-dark-lighter')
  }
  return baseClasses
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}, ref) => {
  const variants = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    ghost: 'btn-ghost',
    danger: 'btn-danger',
    outline: 'border border-brand-gray/30 hover:bg-brand-dark-lighter',
    default: 'bg-brand-dark-lighter hover:bg-brand-dark',
    link: 'text-brand-primary hover:underline'
  }

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  }

  return (
    <button
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center rounded-monumenta font-medium transition-all duration-200',
        'hover:scale-105 hover:shadow-monumenta-brand disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
})

Button.displayName = 'Button'